<div class="sb-wrapper" data-sidenav-state="rail">
  <app-header (emitOption)="onLogout()"></app-header>
  <div class="sb-page-body">
    <app-sidebar></app-sidebar>
    <main class="sb-main">
      <div class="sb-main-content">
        <router-outlet></router-outlet>
      </div>
      <app-footer></app-footer>
    </main>
  </div>
</div>
